import { type FunctionComponent } from 'react';
import { Modal } from '../../common-components/modal/modal.component';
import { LoginCustomerList, type LoginCustomerListProps } from '../login-customer-list/login-customer-list.component';

export type LoginCustomerModalProps = {
	onClose?: () => void;
} & LoginCustomerListProps;

export const LoginCustomerModal: FunctionComponent<LoginCustomerModalProps> = ({ onClose, ...props }) => (
	<Modal title="Login as Customer" closeAction={onClose} size="large">
		<div className="tl">
			<LoginCustomerList {...props} />
		</div>
	</Modal>
);
